/* OFERTA B — controlador da compra (peça + top como acréscimo).
   Lê o JSON que o snippet tp-oferta-b emite, desenha cores/tamanhos a partir
   das variantes reais, soma o preço pela variante escolhida e adiciona ao
   carrinho pelo mesmo caminho das caixas de lançamento (fetch em /cart/add.js
   com as seções da gaveta). ES5 de propósito: a página é aberta em celular
   antigo. */
(function () {
  'use strict';
  function inicia(raiz) {
    if (raiz.getAttribute('data-ob-pronto')) return;
    raiz.setAttribute('data-ob-pronto', '1');
    var dados;
    try { dados = JSON.parse(raiz.querySelector('[data-ob-data]').textContent); } catch (e) { return; }
    if (!dados.pecas || !dados.pecas.legging) return;
    // TESTE DE PREÇO (VWO): preço do grupo da cliente nas variantes; daqui em diante tudo sai dele
    // (preço, parcela, total com o top, barra fixa). Ver snippets/tp-teste-preco.liquid.
    if (window.tpTestePreco) window.tpTestePreco.ajustarOferta(dados);

    var q = function (s) { return raiz.querySelector(s); };
    var qa = function (s) { return [].slice.call(raiz.querySelectorAll(s)); };
    var fixa = q('[data-ob-fixa]');
    var presente = raiz.getAttribute('data-presente') === '1';
  var pecaNome = raiz.getAttribute('data-peca') || 'top', pecaDe = raiz.getAttribute('data-peca-de') || 'do top'; // nome da peça do acréscimo nos textos (não confundir com peca(), a legging escolhida)
    var travaPar = raiz.getAttribute('data-par') === '1';
    // reenvio 17/09/2026: o push anterior foi recusado pela Shopify por um range inválido na seção tp-e-blackout-v1
    var prevenda = raiz.getAttribute('data-prevenda') === '1';
    // pré-venda v2: o prazo existe, mas o despacho é uma data FIXA (o dia do envio), sem corte e sem consultar a transportadora
    var despachoFixo = null; (function () { var d = raiz.getAttribute('data-ob-despacho'); if (d && /^\d{4}-\d{2}-\d{2}$/.test(d)) { var q3 = d.split('-'); despachoFixo = new Date(+q3[0], +q3[1] - 1, +q3[2]); } })();    var freteGratis = raiz.getAttribute('data-frete-gratis') === '1'; // frete grátis colado no parcelamento e na barra fixa // pré-venda: o bloco de prazo nem existe no HTML, então não se inicia
    // brinde do PAR (lenço da pré-venda): chip e miniatura sempre que o acréscimo existe. Quem põe no carrinho é o tp-presente.
    var brindePar = (dados.brindePar && dados.brindePar.rotulo) ? dados.brindePar : null;
    var ICO_PRESENTE = '<svg viewBox="0 0 24 24"><path d="M4 10h16v10H4zM2 7h20v3H2zM12 7v13M12 7c-2-3-6-3-6-1s3 1 6 1c3 0 6 1 6-1s-4-2-6 1"/></svg>';
    var ICO_FRETE = '<svg viewBox="0 0 24 24"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>';
    var parcelas = parseInt(raiz.getAttribute('data-parcelas'), 10) || 3;
    var parcMin = parseInt(raiz.getAttribute('data-parcela-minima'), 10) || 0;
    var CFG = {
      corte: parseInt(raiz.getAttribute('data-corte'), 10) || 16,
      min: parseInt(raiz.getAttribute('data-uteis-min'), 10) || 3,
      max: parseInt(raiz.getAttribute('data-uteis-max'), 10) || 7
    };
    var HEX = { preto: '#1a1a1a', bosque: '#2e4a3d', cereja: '#c50b39', cafe: '#7b4a2d', 'azul marinho': '#1d2a44', marinho: '#1d2a44', 'verde oliva': '#6b7f5a', branco: '#f2f2f2', bege: '#d9c7b2', vinho: '#5a1f2b', rosa: '#e8a5b3', cinza: '#8a8a8a', azul: '#2c3e6b' };

    var st = { pecaKey: 'legging', cor: null, tam: null, comTop: presente, corTop: null, topEscolhido: false, tamTop: null };
    // Girou a roleta nesta pagina: os ganhos do acrescimo passam a incluir o presente misterioso na hora.
    document.addEventListener('tp:roleta-presente', function () { try { pinta(); } catch (e) {} });
    /* COR PELA URL (?cor=Preto), 28/09/2026: quem chega por link com cor ja cai nela. Se a cor for de um
       produto LIGADO a versao atual, o conteudo desse produto e carregado em memoria (trocarConteudo). */
    var corUrl = null;
    try { corUrl = new URLSearchParams(window.location.search).get('cor'); } catch (e) {}
    if (corUrl) st.cor = corUrl;
    /* COR DO DIA (16/10/2026, LipLegging 17-19/10): uma cor da peca com X% OFF no carrinho (desconto automatico
       nas variantes dela). Sem cor pela URL, a pagina abre nela; a bolinha leva o selo "-X%" e, escolhida, o preco
       aparece com o cheio riscado. A faixa da oferta e o relogio ficam no tp-cronometro-topo. */
    var CP = (dados.corPromo && dados.corPromo.cor && dados.corPromo.pct > 0 && (!dados.corPromo.fim || Date.now() < dados.corPromo.fim * 1000)) ? dados.corPromo : null;
    function emPromo(prod, cor) { return !!(CP && prod && prod.handle === CP.handle && cor === CP.cor); }
    if (!st.cor && CP) st.cor = CP.cor;
    /* COR DO BRINDE (20/10/2026, LipLegging Cafe): no compre e ganhe, o top gratis so vale com a legging nessa cor
       (o BXGY pega so as variantes dela). As outras cores seguem a venda, sem o top: o acrescimo vira um aviso.
       A pagina abre nela, ela vem primeiro nas duas fileiras e a bolinha da legging leva o selo. Passou do `fim`,
       nenhuma cor leva o top. A com bolso grafa "Cafe" sem acento: a cor e comparada sem acento. */
    var CB = (presente && dados.corBrinde && dados.corBrinde.cor) ? dados.corBrinde : null;
    var cbEncerrado = !!(CB && CB.fim && Date.now() >= CB.fim * 1000);
    function ehCorBrinde(cor) { return !!(CB && cor && semAcento(cor) === semAcento(CB.cor)); }
    function brindeOk() { return !CB || (!cbEncerrado && ehCorBrinde(st.cor)); }
    function equivCor(p, cor) { if (!p || !cor) return null; var cs = cores(p), n = semAcento(cor); for (var i = 0; i < cs.length; i++) { if (semAcento(cs[i]) === n) return cs[i]; } return null; }
    if (!st.cor && CB) st.cor = CB.cor;
    // TOP A ESCOLHA (20/10/2026): `topKey` diz qual dos dois tops gratis (dados.pecas.top | topAlt) esta escolhido
    st.topKey = 'top';
    // O PRODUTO DA PAGINA: quem abriu a pagina. Nao muda com as trocas de conteudo em memoria -- e ele
    // que fixa a ordem das cores (as dele primeiro) e e a galeria dele que fica na tela.
    var PAGINA = window.__tpObPagina = window.__tpObPagina || dados.pecas.legging.handle;

    /* FOTO DA COR (28/09/2026, v2): ao escolher uma cor, a foto ativa da galeria vira a foto ligada a ela --
       a midia destacada da variante ou, sem ela, a primeira foto cujo alt tem o nome da cor ("branc" casa
       "branco"). SEM O setActiveMedia DO TEMA: ele rola a JANELA ate a galeria quando ela esta fora da tela,
       e e isso que o Guilherme chamou de "tela arrastando sozinha". Aqui so muda o que e da galeria: a
       classe is-active, a rolagem da lista de fotos (celular) e a miniatura marcada (desktop). A pagina nao
       se move. No celular a lista tem scroll-snap "x mandatory", e o Chromium cancela rolagem programatica
       nesse estado: o snap e desligado por um instante e religado por temporizador. */
    function irParaFoto(prod, cor) {
      var gal = document.querySelector('media-gallery');
      if (!gal || !cor) return;
      var alvo = null;
      if (prod) { var v = variante(prod, cor, null); if (v && v.mediaId) alvo = gal.querySelector('.product__media-item[data-media-id$="-' + v.mediaId + '"]'); }
      if (!alvo) {
        var radical = semAcento(cor).replace(/o$/, '');
        var itens = [].slice.call(gal.querySelectorAll('.product__media-item[data-media-id]'));
        for (var i = 0; i < itens.length && !alvo; i++) { var img = itens[i].querySelector('img'); if (img && semAcento(img.getAttribute('alt') || '').indexOf(radical) > -1) alvo = itens[i]; }
      }
      if (!alvo) return;
      var id = alvo.getAttribute('data-media-id'), lista = alvo.parentElement;
      [].slice.call(lista.querySelectorAll('[data-media-id]')).forEach(function (el) { el.classList.remove('is-active'); });
      alvo.classList.add('is-active');
      if (lista.scrollWidth - lista.clientWidth > 8) {
        var snap = lista.style.scrollSnapType, beh = lista.style.scrollBehavior;
        lista.style.scrollSnapType = 'none'; lista.style.scrollBehavior = 'auto';
        lista.scrollLeft = alvo.offsetLeft;
        setTimeout(function () { lista.style.scrollSnapType = snap; lista.style.scrollBehavior = beh; }, 80);
      }
      var thumbs = gal.querySelector('.thumbnail-list');
      if (thumbs) {
        [].slice.call(thumbs.querySelectorAll('button')).forEach(function (b) { b.removeAttribute('aria-current'); });
        var mini = thumbs.querySelector('[data-target="' + id + '"]');
        if (mini) { var bt = mini.querySelector('button'); if (bt) bt.setAttribute('aria-current', 'true'); try { thumbs.scrollTo({ left: mini.offsetLeft, behavior: 'smooth' }); } catch (e) {} }
      }
      try { if (typeof gal.playActiveMedia === 'function') gal.playActiveMedia(alvo); } catch (e) {}
    }

    /* ---------- COR LIGADA: a PDP do outro produto DENTRO desta pagina, sem recarregar ----------
       A LipLegging Branca com Bolso e produto proprio (SKUs, estoque, PDP Blackout). Aqui ela e "a
       cor Branco" da LipLegging com Bolso -- e vice-versa. Mesma tecnica do tp-versao-switcher.js
       (botao com/sem bolso das PDPs com seletor do tema): busca a pagina do outro produto, troca o
       #MainContent, re-executa os scripts inline das secoes (carrosseis, modais, cronometro) e avisa
       com shopify:section:load (que este arquivo e o animations.js escutam) e tp:versao:trocada
       (reviews). O LINK NAO MUDA: so entra ?cor=<nome> (pedido do Guilherme: como o botao com/sem
       bolso, sem recarregar). Ida e volta ficam em cache; as paginas ligadas sao pre-carregadas na
       folga do navegador, entao a troca costuma ser instantanea.
       A cor ligada e DA VERSAO selecionada (dados.corLigadaDe[st.pecaKey]): na pagina da sem bolso,
       Branco so aparece depois de trocar para "Com bolso". */
    function ligadaDe(key) { var l = (dados.corLigadaDe || {})[key || st.pecaKey]; return (l && l.produto && l.produto.url && l.produto.variants) ? l : null; }
    var cacheHtml = window.__tpObCache = window.__tpObCache || {};
    function buscarHtml(url) {
      if (cacheHtml[url]) return Promise.resolve(cacheHtml[url]);
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }).then(function (h) { cacheHtml[url] = h; return h; });
    }
    function urlLigada(lg, c) { var u = lg.produto.url; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'cor=' + encodeURIComponent(c); }
    function reexecutaScripts(escopo) {
      [].slice.call(escopo.querySelectorAll('script')).forEach(function (s) {
        var tipo = (s.getAttribute('type') || '').toLowerCase();
        if (tipo && tipo !== 'text/javascript' && tipo !== 'module') return; // JSON das secoes fica como esta
        if (s.src) {
          var base = s.src.split('?')[0];
          var jaTem = [].slice.call(document.scripts).some(function (x) { return x !== s && x.src && x.src.split('?')[0] === base; });
          if (jaTem) return; // web components e este arquivo ja estao vivos; repetir o <script src> so duplicaria
        }
        var novo = document.createElement('script');
        [].slice.call(s.attributes).forEach(function (a) { novo.setAttribute(a.name, a.value); });
        novo.textContent = s.textContent;
        s.parentNode.replaceChild(novo, s);
      });
    }
    function trazEstilos(doc) {
      [].slice.call(doc.querySelectorAll('link[rel="stylesheet"]')).forEach(function (l) {
        var href = l.getAttribute('href'); if (!href) return;
        var base = href.split('?')[0];
        var jaTem = [].slice.call(document.querySelectorAll('link[rel="stylesheet"]')).some(function (x) { return (x.getAttribute('href') || '').split('?')[0] === base; });
        if (!jaTem) { var novo = document.createElement('link'); novo.rel = 'stylesheet'; novo.href = href; document.head.appendChild(novo); }
      });
    }
    /* ANIMACAO DA TROCA (28/09/2026, pedido do Guilherme): o que vai trocar -- a coluna de compra e as secoes
       abaixo -- esmaece por uns 190 ms, o conteudo novo entra esmaecendo de volta; a galeria (que e da pagina) nao
       participa. So opacidade, sem transform: transform em ancestral quebraria a barra fixa da caixa. */
    function alvosTroca(main) {
      var out = [];
      [].slice.call(main.querySelectorAll('.shopify-section')).forEach(function (sec) {
        if (sec.querySelector('media-gallery')) { var info = sec.querySelector('.product__info-wrapper'); out.push(info || sec); }
        else out.push(sec);
      });
      return out;
    }
    var trocando = false;
    function trocarConteudo(lg, c) {
      if (trocando) return;
      trocando = true;
      raiz.classList.add('tp-ob--trocando'); raiz.setAttribute('aria-busy', 'true');
      var linha = q('[data-ob-cores]'), topoAntes = linha ? linha.getBoundingClientRect().top : null;
      buscarHtml(lg.produto.url).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.querySelector('#MainContent'), atual = document.querySelector('#MainContent');
        if (!novo || !atual) throw new Error('MainContent nao encontrado');
        alvosTroca(atual).forEach(function (el) { el.classList.add('tp-troca-alvo'); });
        atual.classList.add('tp-troca-saindo');
        return new Promise(function (ok) { setTimeout(function () { ok({ doc: doc, novo: novo, atual: atual }); }, 190); });
      }).then(function (x) {
        var doc = x.doc, novo = x.novo, atual = x.atual;
        // o link continua o desta pagina; a cor vai na query, e o JS da pagina nova a le ao iniciar
        try { history.replaceState(null, '', window.location.pathname + '?cor=' + encodeURIComponent(c)); } catch (e) {}
        if (doc.title) document.title = doc.title;
        trazEstilos(doc);
        // A GALERIA E DA PAGINA (Guilherme, 28/09): os dois produtos carregam as fotos de todas as cores, entao a
        // galeria e o lightbox de quem abriu a pagina ficam como estao -- so a foto da cor escolhida vira a ativa.
        var galAntiga = atual.querySelector('media-gallery'), modalAntigo = atual.querySelector('product-modal');
        atual.innerHTML = novo.innerHTML;
        var galNova = atual.querySelector('media-gallery'); if (galAntiga && galNova) galNova.parentNode.replaceChild(galAntiga, galNova);
        var modalNovo = atual.querySelector('product-modal'); if (modalAntigo && modalNovo) modalNovo.parentNode.replaceChild(modalAntigo, modalNovo);
        // As animacoes de entrada do Dawn (scroll-trigger: slide-in das secoes, fade-in das fotos) reiniciam em
        // todo no inserido -- inclusive na galeria reinserida -- e piscariam por cima do fade da troca. Cancela.
        [].slice.call(atual.querySelectorAll('.scroll-trigger')).forEach(function (el) { el.classList.add('scroll-trigger--cancel'); });
        reexecutaScripts(atual);
        try { if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') window.jdgm.customizeBadges(); } catch (e) {}
        [].slice.call(atual.querySelectorAll('.shopify-section')).forEach(function (sec) { document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: sec.id }, bubbles: true })); });
        document.dispatchEvent(new CustomEvent('tp:versao:trocada', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('tp:cor-ligada:trocada', { bubbles: true, detail: { cor: c, url: lg.produto.url } }));
        // foto da cor na galeria da pagina (sem mover a janela). Depois dos scripts do conteudo novo: o product-info
        // do Dawn, ao acordar, volta a galeria para a primeira foto -- entao o pulo roda depois dele (e repete uma vez).
        setTimeout(function () { irParaFoto(null, c); }, 150);
        setTimeout(function () { irParaFoto(null, c); }, 500);
        atual.classList.remove('tp-troca-saindo');
        alvosTroca(atual).forEach(function (el) { el.classList.add('tp-troca-alvo'); });
        atual.classList.add('tp-troca-entrando');
        setTimeout(function () { atual.classList.remove('tp-troca-entrando'); }, 360);
        // a linha de cores nova fica onde a antiga estava: a cliente continua olhando para o mesmo lugar
        var novaLinha = atual.querySelector('[data-ob-cores]');
        if (novaLinha && topoAntes !== null) { var y = novaLinha.getBoundingClientRect().top + window.pageYOffset - topoAntes; window.scrollTo(0, Math.max(0, y)); }
      }).catch(function () {
        window.location.href = urlLigada(lg, c); // falhou a troca em memoria: navega de verdade, nunca deixa a cliente presa
      }).then(function () { trocando = false; raiz.classList.remove('tp-ob--trocando'); raiz.removeAttribute('aria-busy'); });
    }
    /* GALERIA DA VERSAO (16/10/2026): o botao Sem bolso / Com bolso so trocava a caixa; a galeria continuava a
       do produto que abriu a pagina, e a cor escolhida na outra versao caia nas fotos desta (Guilherme: "na com
       bolso ta mostrando as fotos da sem bolso"). Agora a galeria e o lightbox da versao escolhida entram no
       lugar: vem da pagina dela (mesmo cache da cor ligada, pre-carregada na folga) e ficam guardados por
       handle em window, entao ir e voltar nao busca de novo e sobrevive a troca de conteudo da cor ligada.
       Cada galeria leva data-tp-ob-galeria=<handle> para saber de quem ela e. */
    var galerias = window.__tpObGalerias = window.__tpObGalerias || {};
    function galeriaAtual() {
      var main = document.querySelector('#MainContent'); if (!main) return null;
      var gal = main.querySelector('media-gallery'); if (!gal) return null;
      // o lightbox nao fica no #MainContent: o tema o leva para o body ao carregar
      return { gal: gal, modal: main.querySelector('product-modal') || document.querySelector('product-modal'), handle: gal.getAttribute('data-tp-ob-galeria') || PAGINA };
    }
    function galeriaDe(prod) {
      if (galerias[prod.handle]) return Promise.resolve(galerias[prod.handle]);
      return buscarHtml(prod.url).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var gal = doc.querySelector('#MainContent media-gallery'); if (!gal) throw new Error('sem galeria');
        var modal = doc.querySelector('#MainContent product-modal');
        // importNode (e nao adoptNode): cria os nos no documento da pagina, onde os web components do tema acordam
        var g = { gal: document.importNode(gal, true), modal: modal ? document.importNode(modal, true) : null };
        // o modal-dialog do Dawn, ao entrar na pagina, procura a .shopify-section em volta para se mudar para o body;
        // este ja entra direto no body (no lugar do lightbox atual), entao ja chega "mudado" e com a secao certa
        if (g.modal) {
          var secModal = modal.closest('.shopify-section');
          g.modal.moved = true;
          if (secModal) g.modal.dataset.section = secModal.id.replace('shopify-section-', '');
        }
        g.gal.setAttribute('data-tp-ob-galeria', prod.handle);
        // mesma razao da cor ligada: a animacao de entrada do Dawn piscaria as fotos na troca
        [].slice.call(g.gal.querySelectorAll('.scroll-trigger')).forEach(function (el) { el.classList.add('scroll-trigger--cancel'); });
        galerias[prod.handle] = g;
        return g;
      });
    }
    function trocaGaleria(prod) {
      var at = galeriaAtual();
      if (!prod || !prod.url || !at || at.handle === prod.handle) { irParaFoto(prod, st.cor); return; }
      if (!galerias[at.handle]) { at.gal.setAttribute('data-tp-ob-galeria', at.handle); galerias[at.handle] = { gal: at.gal, modal: at.modal }; }
      galeriaDe(prod).then(function (g) {
        var agora = galeriaAtual();
        if (!agora || peca().handle !== prod.handle || agora.handle === prod.handle) return; // a cliente ja trocou de novo
        agora.gal.parentNode.replaceChild(g.gal, agora.gal);
        if (agora.modal && g.modal) agora.modal.parentNode.replaceChild(g.modal, agora.modal);
        irParaFoto(prod, st.cor);
        setTimeout(function () { irParaFoto(prod, st.cor); }, 150); // o slider da galeria acorda e volta para a 1a foto
      }).catch(function () { irParaFoto(prod, st.cor); });
    }
    function prefetchLigadas() {
      ['legging', 'leggingAlt'].forEach(function (k) { var lg = ligadaDe(k); if (lg) buscarHtml(lg.produto.url).catch(function () {}); });
      var alt = dados.pecas.leggingAlt; if (alt && alt.url) buscarHtml(alt.url).catch(function () {});
    }
    if (window.requestIdleCallback) window.requestIdleCallback(prefetchLigadas, { timeout: 4000 }); else setTimeout(prefetchLigadas, 2500);
    // ?cor= de um produto ligado a versao atual (link compartilhado ou recarregado): troca ja, sem recarregar
    (function () { var lg = ligadaDe(); if (corUrl && lg && !corValida(peca(), corUrl) && corValida(lg.produto, corUrl)) trocarConteudo(lg, corUrl); })();


    /* ---------- utilidades ---------- */
    function semAcento(s) { return String(s || '').normalize ? String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase() : String(s).toLowerCase(); }
    function brl(c) { return (dados.moeda || 'R$') + ' ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    function parcela(c) {
      if (!parcelas || parcelas < 2) return '';
      var n = parcelas;
      if (parcMin > 0) { n = Math.min(parcelas, Math.max(1, Math.floor(c / parcMin))); }
      if (n < 2) return '';
      return n + 'x de ' + brl(Math.floor(c / n)) + ' sem juros'; // arredonda para baixo, como o resto do tema (R$ 449,90 em 9x = 49,98)
    }
    var toastEl = q('[data-ob-toast]'), toastTimer;
    function toast(msg) { if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add('tp-ob--on'); clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('tp-ob--on'); }, 2400); }
    function pressiona(container, alvo) { [].slice.call(container.children).forEach(function (x) { x.setAttribute('aria-pressed', x === alvo ? 'true' : 'false'); }); }

    /* ---------- leitura das variantes ---------- */
    function peca() { return dados.pecas[st.pecaKey] || dados.pecas.legging; }
    function top() { return dados.pecas[st.topKey] || dados.pecas.top; }
    /* AVISE-ME (19/10/2026): a peça escolhida que está esgotada (a principal primeiro, depois a do acréscimo) */
    var ROTULO_CTA = q('[data-ob-cta-texto]').textContent, ROTULO_FIXA = fixa.querySelector('[data-ob-fixa-cta]').textContent;
    function rotuloAvise(id) { return window.tpAviseMe ? window.tpAviseMe.rotulo(id) : 'Avise-me quando chegar'; }
    function nomeItem(p, cor, tam) { return (p.title || '') + ' (' + [cor, tam].filter(Boolean).join(' / ') + ')'; }
    function esgotadoEscolhido() {
      var p = peca(), t = top(), v;
      if (st.tam && (v = variante(p, st.cor, st.tam)) && !v.available) return { v: v, item: nomeItem(p, st.cor, st.tam) };
      if (st.comTop && t && st.tamTop && (v = variante(t, st.corTop, st.tamTop)) && !v.available) return { v: v, item: nomeItem(t, st.corTop, st.tamTop) };
      return null;
    }
    function cores(p) {
      if (!p || p.colorIndex < 0) return [];
      var out = [];
      p.variants.forEach(function (v) { var c = v.options[p.colorIndex]; if (out.indexOf(c) < 0) out.push(c); });
      return out;
    }
    function tamanhos(p, cor) {
      if (!p || p.sizeIndex < 0) return [];
      var out = [], vistos = {};
      p.variants.forEach(function (v) {
        if (p.colorIndex > -1 && cor && v.options[p.colorIndex] !== cor) return;
        var t = v.options[p.sizeIndex];
        if (vistos[t] === undefined) { vistos[t] = out.length; out.push({ nome: t, disponivel: !!v.available, id: v.id, price: v.price }); }
        else if (v.available) { out[vistos[t]].disponivel = true; out[vistos[t]].id = v.id; out[vistos[t]].price = v.price; }
      });
      var ordem = p.tamanhosOrdem || [];
      if (ordem.length) out.sort(function (a, b) { return ordem.indexOf(a.nome) - ordem.indexOf(b.nome); });
      return out;
    }
    function variante(p, cor, tam) {
      if (!p) return null;
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (p.colorIndex > -1 && cor && v.options[p.colorIndex] !== cor) continue;
        if (p.sizeIndex > -1 && tam && v.options[p.sizeIndex] !== tam) continue;
        return v;
      }
      return null;
    }
    function precoDe(p, cor, tam) {
      var v = variante(p, cor, tam);
      if (v) return v.price;
      var vs = p.variants.filter(function (x) { return p.colorIndex < 0 || !cor || x.options[p.colorIndex] === cor; });
      var disp = vs.filter(function (x) { return x.available; })[0] || vs[0] || p.variants[0];
      return disp ? disp.price : 0;
    }
    // "comparar com" da variante (0 = sem). Mesma escolha de variante do precoDe.
    function riscadoDe(p, cor, tam) {
      var v = variante(p, cor, tam);
      if (!v) {
        var vs = p.variants.filter(function (x) { return p.colorIndex < 0 || !cor || x.options[p.colorIndex] === cor; });
        v = vs.filter(function (x) { return x.available; })[0] || vs[0] || p.variants[0];
      }
      return v && v.compare ? v.compare : 0;
    }
    var comRiscado = raiz.getAttribute('data-riscado') === '1';
    function fotoDe(p, cor) {
      var vs = p.variants.filter(function (x) { return p.colorIndex < 0 || !cor || x.options[p.colorIndex] === cor; });
      return (vs[0] && vs[0].image) || p.capa;
    }
    function corValida(p, cor) { return cores(p).indexOf(cor) > -1; }
    // todas as fotos da cor, pelo alt das mídias ("preta" e "preto" casam pelo radical "pret").
    // Sem alt marcado (LipBailarina), vale a série do arquivo da variante: "PDP1.1_..." puxa PDP1.3, PDP1.4...
    // Sem série, fica só a foto da variante.
    function arquivoDe(u) { return String(u || '').split('/').pop().split('?')[0]; }
    function fotosDe(p, cor) {
      var radical = semAcento(cor).replace(/o$/, '');
      var lista = (p.midias || []).filter(function (m) { return m.alt && semAcento(m.alt).indexOf(radical) > -1; }).map(function (m) { return m.url; });
      if (lista.length) return lista;
      var capa = fotoDe(p, cor), serie = arquivoDe(capa).split('.')[0];
      if (serie && arquivoDe(capa).indexOf('.') > 0) lista = (p.midias || []).filter(function (m) { return arquivoDe(m.url).indexOf(serie + '.') === 0; }).map(function (m) { return m.url; });
      return lista.length > 1 ? lista : [capa];
    }

    /* ---------- desenho ---------- */
    /* COR LIGADA (28/09/2026): alem das cores da peca, a linha mostra as cores do produto ligado A
       VERSAO ATUAL (ligadaDe()) depois de uma linha fina; escolher uma delas troca o conteudo da pagina
       em memoria (trocarConteudo). O grupo com rotulo (cor_ligada_rotulo -- a Branca: "Lancamento")
       leva contorno coral e o selo miudo na bolinha. As cores DESTA peca vem sempre primeiro: na
       LipLegging com Bolso o Branco e o ultimo; na pagina da Branca ele e o primeiro e ja selecionado.
       So na linha de cores da PECA ([data-ob-cores]); as cores do acrescimo (top) seguem como antes. */
    function desenhaCores(container, p, corAtual, aoEscolher) {
      if (!container) return;
      container.innerHTML = '';
      function botao(c, prod, destaque, ligada) {
        var b = document.createElement(ligada ? 'a' : 'button');
        if (ligada) b.href = urlLigada(ligada, c); else b.type = 'button';
        b.className = 'tp-ob__cor' + (destaque ? ' tp-ob__cor--destaque' : '');
        b.setAttribute('aria-pressed', (!ligada && c === corAtual) ? 'true' : 'false'); b.setAttribute('data-cor', c); b.setAttribute('aria-label', c);
        var hex = HEX[semAcento(c)] || '#c9cbc2', sw = (prod.swatches || {})[c];
        var i = document.createElement('i'); i.style.backgroundColor = hex; if (sw) i.style.backgroundImage = 'url(' + sw + ')';
        var s = document.createElement('small'); s.textContent = c === 'Azul Marinho' ? 'Marinho' : c;
        if (typeof destaque === 'string' && destaque) { var em = document.createElement('em'); em.textContent = destaque; b.appendChild(em); }
        b.appendChild(i); b.appendChild(s);
        if (!ligada && container.hasAttribute('data-ob-cores') && emPromo(prod, c)) {
          b.className += ' tp-ob__cor--promo';
          var off = document.createElement('em'); off.className = 'tp-ob__cor-off'; off.textContent = '-' + CP.pct + '%';
          b.insertBefore(off, b.firstChild); b.setAttribute('aria-label', c + ', ' + CP.pct + '% OFF');
        }
        if (!ligada && container.hasAttribute('data-ob-cores') && CB && !cbEncerrado && ehCorBrinde(c)) {
          b.className += ' tp-ob__cor--promo';
          var selo = document.createElement('em'); selo.className = 'tp-ob__cor-off'; selo.textContent = CB.selo || 'Top grátis';
          b.insertBefore(selo, b.firstChild); b.setAttribute('aria-label', c + ', ' + (CB.selo || 'Top grátis'));
        }
        if (!ligada) b.addEventListener('click', function () { aoEscolher(c); });
        else b.addEventListener('click', function (ev) { if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button === 1) return; ev.preventDefault(); trocarConteudo(ligada, c); });
        container.appendChild(b);
      }
      function sep() { var e = document.createElement('span'); e.className = 'tp-ob__cor-sep'; e.setAttribute('aria-hidden', 'true'); container.appendChild(e); }
      var lg = container.hasAttribute('data-ob-cores') ? ligadaDe() : null;
      var proprias = cores(p), outras = lg ? cores(lg.produto) : [];
      // cor do dia: primeira da fileira, para a bolinha com o selo nunca ficar escondida no canto
      if (container.hasAttribute('data-ob-cores') && CP && p.handle === CP.handle && proprias.indexOf(CP.cor) > 0) { proprias.splice(proprias.indexOf(CP.cor), 1); proprias.unshift(CP.cor); }
      // cor do brinde: primeira nas duas fileiras (legging e top)
      if (CB) { var cbI = -1; proprias.forEach(function (c, k) { if (cbI < 0 && ehCorBrinde(c)) cbI = k; }); if (cbI > 0) proprias.unshift(proprias.splice(cbI, 1)[0]); }
      var meuRot = lg ? String(lg.meuRotulo || '') : '', rotLig = lg ? String(lg.rotulo || '') : '';
      // ORDEM FIXA PELA PAGINA (Guilherme, 28/09): as cores do produto DA PAGINA vem primeiro, sempre -- mesmo
      // depois de trocar o conteudo. Na LipLegging com Bolso o Branco e o ultimo ate quando esta selecionado;
      // na pagina da Branca ele e o primeiro ate quando outra cor esta selecionada.
      var ligadoPrimeiro = !!(lg && lg.produto.handle === PAGINA && p.handle !== PAGINA);
      if (ligadoPrimeiro) {
        outras.forEach(function (c) { botao(c, lg.produto, rotLig || false, lg); });
        if (proprias.length) sep();
        proprias.forEach(function (c) { botao(c, p, meuRot || false, null); });
      } else {
        proprias.forEach(function (c) { botao(c, p, meuRot || false, null); });
        if (outras.length) sep();
        outras.forEach(function (c) { botao(c, lg.produto, rotLig || false, lg); });
      }
      duasLinhas(container);
      ajustaFileira(container);
      // a fileira pode nascer escondida (troca de conteudo para a Branca) e so ganhar largura depois: quando o
      // espaco dela (o pai, cuja largura nao depende da grade) muda de tamanho, mede de novo
      if (window.ResizeObserver && !container.__tpObRo && container.parentElement) {
        container.__tpObRo = new ResizeObserver(function () { ajustaFileira(container); });
        container.__tpObRo.observe(container.parentElement);
      }
    }
    /* CORES EM DUAS LINHAS (19/10/2026, Guilherme): as cores de sempre em cima (Preto, Cereja, Cafe, Azul Marinho)
       e as novas embaixo (Branco quando houver, depois Bosque, Mirtilo, Cacau na ordem do cadastro), com uma linha
       fina entre elas. Vale para qualquer produto cujas cores sejam todas dessas duas listas, com pelo menos 3
       classicas e 2 novas (Lip, Lip com Bolso, Branca, Top Basic); o resto continua numa fileira so. Os botoes
       ja desenhados so mudam de lugar (os cliques vao junto); dentro de cada linha vale a ordem que ja vinha
       (cor do dia / cor do brinde primeiro). O separador vertical da cor ligada sai: a Branca vira a 1a das novas. */
    var CORES_CLASSICAS = ['preto', 'cereja', 'cafe', 'azul marinho'], CORES_NOVAS = ['branco', 'bosque', 'mirtilo', 'cacau'];
    function duasLinhas(cont) {
      if (!cont) return;
      cont.classList.remove('tp-ob__cores--2l');
      var bts = [].slice.call(cont.querySelectorAll('.tp-ob__cor'));
      var nome = function (b) { return semAcento(b.getAttribute('data-cor') || '').trim(); };
      var antigas = [], novas = [];
      for (var i = 0; i < bts.length; i++) {
        var n = nome(bts[i]);
        if (CORES_CLASSICAS.indexOf(n) > -1) antigas.push(bts[i]);
        else if (CORES_NOVAS.indexOf(n) > -1) novas.push(bts[i]);
        else return; // cor fora das duas listas: fica como esta
      }
      if (antigas.length < 3 || novas.length < 2) return;
      novas.sort(function (a, b) { return (nome(a) === 'branco' ? 0 : 1) - (nome(b) === 'branco' ? 0 : 1); });
      [].slice.call(cont.querySelectorAll('.tp-ob__cor-sep, .tp-ob__cor-quebra')).forEach(function (el) { el.parentNode.removeChild(el); });
      antigas.forEach(function (b) { cont.appendChild(b); });
      // o rotulo explica a separacao (Guilherme: sem ele, so quem sabe dos lancamentos entende por que ha duas linhas)
      var quebra = document.createElement('span'); quebra.className = 'tp-ob__cor-quebra'; quebra.textContent = 'Novas cores';
      cont.appendChild(quebra);
      novas.forEach(function (b) { cont.appendChild(b); });
      cont.classList.add('tp-ob__cores--2l');
    }
    /* FILEIRA EM GRADE (16/10/2026): se as bolinhas quebram em duas linhas, a fileira vira grade de 2 linhas
       equilibradas (ver o CSS). Com cor ligada (a Branca: outra PDP, outro ponto de venda), o grupo dela NAO entra
       na grade das outras cores (Guilherme: "precisa ser mostrado como especial"): fica numa coluna propria, do lado
       em que ja estava, atras do traco separador, centrado na altura das duas linhas. Mede de novo a cada desenho e
       quando a janela muda (as posicoes vao no style de cada filho e sao limpas antes de medir). */
    function ajustaFileira(cont) {
      if (!cont) return;
      var filhos = [].slice.call(cont.children);
      cont.classList.remove('tp-ob__cores--grade');
      cont.style.gridTemplateColumns = '';
      filhos.forEach(function (el) { el.style.gridColumn = ''; el.style.gridRow = ''; el.style.alignSelf = ''; });
      if (cont.classList.contains('tp-ob__cores--2l')) return;
      if (filhos.length < 2 || filhos[filhos.length - 1].offsetTop <= filhos[0].offsetTop + 2) return;
      var iSep = -1;
      for (var i = 0; i < filhos.length; i++) if (filhos[i].classList.contains('tp-ob__cor-sep')) { iSep = i; break; }
      var COL = 'minmax(0,1fr)';
      function repete(n) { var r = []; for (var j = 0; j < n; j++) r.push(COL); return r.join(' '); }
      // itens em 2 linhas, a partir da coluna "desde" (contando de 1)
      function grade(itens, desde) {
        var cols = Math.ceil(itens.length / 2);
        itens.forEach(function (el, k) { el.style.gridRow = String(k < cols ? 1 : 2); el.style.gridColumn = String(desde + (k % cols)); });
      }
      if (iSep < 0) {
        cont.style.gridTemplateColumns = repete(Math.ceil(filhos.length / 2));
        grade(filhos, 1);
      } else {
        var antes = filhos.slice(0, iSep), depois = filhos.slice(iSep + 1), sepEl = filhos[iSep];
        var espPrimeiro = antes.length < depois.length;
        var esp = espPrimeiro ? antes : depois, resto = espPrimeiro ? depois : antes;
        var cEsp = Math.ceil(esp.length / 2), cResto = Math.ceil(resto.length / 2);
        var col = 1;
        var poeEsp = function () {
          if (esp.length === 1) { esp[0].style.gridColumn = String(col); esp[0].style.gridRow = '1 / span 2'; esp[0].style.alignSelf = 'center'; }
          else grade(esp, col);
          col += cEsp;
        };
        var poeSep = function () { sepEl.style.gridColumn = String(col); sepEl.style.gridRow = '1 / span 2'; col += 1; };
        if (espPrimeiro) { poeEsp(); poeSep(); grade(resto, col); col += cResto; }
        else { grade(resto, col); col += cResto; poeSep(); poeEsp(); }
        cont.style.gridTemplateColumns = espPrimeiro
          ? repete(cEsp) + ' auto ' + repete(cResto)
          : repete(cResto) + ' auto ' + repete(cEsp);
      }
      cont.classList.add('tp-ob__cores--grade');
    }
    var tFileira = null;
    window.addEventListener('resize', function () {
      clearTimeout(tFileira);
      tFileira = setTimeout(function () { ajustaFileira(q('[data-ob-cores]')); ajustaFileira(q('[data-ob-cores-top]')); }, 150);
    });
    function desenhaTamanhos(container, p, cor, tamAtual, aoEscolher) {
      if (!container) return;
      container.innerHTML = '';
      tamanhos(p, cor).forEach(function (t) {
        var b = document.createElement('button');
        // AVISE-ME (19/10/2026): o esgotado continua clicável (marcado como esgotado); escolhido, o botão vira "Avise-me quando chegar"
        b.type = 'button'; b.className = 'tp-ob__tam' + (t.disponivel ? '' : ' tp-ob__tam--esgotado'); b.textContent = t.nome; b.setAttribute('aria-pressed', t.nome === tamAtual ? 'true' : 'false');
        b.addEventListener('click', function () { aoEscolher(t.nome); });
        container.appendChild(b);
      });
    }


    function pinta() {
      var p = peca(), t = top();
      if (!corValida(p, st.cor)) st.cor = (CB ? equivCor(p, st.cor) : null) || cores(p)[0] || null;
      if (st.tam && !tamanhos(p, st.cor).some(function (x) { return x.nome === st.tam; })) st.tam = null; // esgotado fica escolhido (avise-me)
      if (t) {
        if (CB) {
          // cor do brinde: o top abre nela; escolhida outra e trocado o top, fica a equivalente
          if (!st.topEscolhido) st.corTop = equivCor(t, CB.cor) || equivCor(t, st.cor) || cores(t)[0] || null;
          else if (!corValida(t, st.corTop)) st.corTop = equivCor(t, st.corTop) || equivCor(t, CB.cor) || cores(t)[0] || null;
        } else if (!st.topEscolhido || !corValida(t, st.corTop)) st.corTop = corValida(t, st.cor) ? st.cor : (cores(t)[0] || null);
        if (st.tamTop && !tamanhos(t, st.corTop).some(function (x) { return x.nome === st.tamTop; })) st.tamTop = null;
      }
      var leg = precoDe(p, st.cor, st.tam), topP = t ? precoDe(t, st.corTop, st.tamTop) : 0;
      var promoOn = emPromo(p, st.cor), legCheio = leg;
      if (promoOn) leg = Math.round(leg * (100 - CP.pct) / 100);
      raiz.classList.toggle('tp-ob--cor-promo', promoOn);
      // cor do brinde: fora dela o top sai do carrinho; voltando a ela, entra de novo
      var cbOk = brindeOk();
      if (CB && t) { if (!cbOk) st.comTop = false; else if (st.cbAntes === false) st.comTop = true; st.cbAntes = cbOk; }
      // no presente o top sai pelo resíduo do kit_preco (R$ 1,00 na anticelulite) ou grátis (resíduo zero)
      var topPago = (presente && t) ? (dados.kitPreco > 0 ? Math.max(0, dados.kitPreco - leg) : 0) : topP;
      var total = st.comTop && t ? leg + topPago : leg;

      // Preço riscado (28/09/2026): só em página de peça avulsa (data-riscado, ver tp-oferta-b.liquid).
      var de = promoOn ? legCheio : (comRiscado ? riscadoDe(p, st.cor, st.tam) : 0);
      q('[data-ob-preco]').innerHTML = (de > leg ? '<s class="tp-ob__de">' + brl(de) + '</s>' : '') + brl(leg) + (promoOn ? '<i class="tp-ob__cp-off">-' + CP.pct + '%</i>' : '');
      q('[data-ob-parcela]').textContent = parcela(leg); // frete grátis NÃO entra aqui (pedido de 17/09): fica na faixa, na microlinha e na barra fixa
      // 1 HORA DE DESCONTOS COM CUPOM (28/10/2026): tag "R$ X com AGORA20" numa linha propria, logo
      // abaixo da caixa do preco (o data-riscado ja vem desligado nessas paginas: so preco + tag)
      var uhCod = raiz.getAttribute('data-ob-uh-codigo'), uhPct = +raiz.getAttribute('data-ob-uh-pct') || 0;
      if (uhCod && uhPct > 0) {
        var uhBox = q('.tp-ob__cab'), uhTag = raiz.querySelector('[data-ob-uh-cupom]');
        if (uhBox && !uhTag) { uhTag = document.createElement('p'); uhTag.className = 'tp-pcf__cupom tp-ob__uh-cupom'; uhTag.setAttribute('data-ob-uh-cupom', ''); uhBox.parentNode.insertBefore(uhTag, uhBox.nextSibling); }
        if (uhTag) uhTag.innerHTML = '<b>' + brl(Math.round(leg * (100 - uhPct) / 100)) + '</b> com <b class="tp-pcf__cupom-cod">' + uhCod + '</b>';
      }
      // DESCONTO PROGRESSIVO (06/10/2026, pedido do Guilherme): o preco mostrado e SEMPRE o de 1 peca
      // (o desconto entra no carrinho); com o top junto sao 2 pecas, e a barra fixa usa o degrau de 2.
      var pg = dados.prog, pgNiv = (pg && pg.niveis) ? String(pg.niveis).split('|').map(function (s) { var kv = s.split(':'); return { n: +kv[0] || 0, pct: +kv[1] || 0 }; }) : [];
      function pgPct(n) { var p = 0; pgNiv.forEach(function (x) { if (n >= x.n) p = x.pct; }); return p; }
      var pgTotal = total;
      if (pg && pg.pct > 0) {
        var leg1 = Math.round(leg * (100 - pg.pct) / 100);
        q('[data-ob-preco]').innerHTML = '<s class="tp-ob__de">' + brl(leg) + '</s>' + brl(leg1);
        q('[data-ob-parcela]').textContent = parcela(leg1);
        // Influs: o preco com o cupom numa linha PROPRIA, logo abaixo da caixa do preco (06/10: dentro do preco quebrava o layout)
        var precoBox = q('.tp-ob__preco'), linhaRow = precoBox && precoBox.parentNode, linhaCupom = linhaRow && linhaRow.parentNode.querySelector('[data-ob-prog-cupom]');
        if (pg.cupomPct > 0 && precoBox) {
          if (!linhaCupom) { linhaCupom = document.createElement('p'); linhaCupom.className = 'tp-ob__prog-cupom'; linhaCupom.setAttribute('data-ob-prog-cupom', ''); linhaRow.parentNode.insertBefore(linhaCupom, linhaRow.nextSibling); }
          linhaCupom.innerHTML = '<b>' + brl(Math.round(leg1 * (100 - pg.cupomPct) / 100)) + '</b> com o cupom da sua influ <span>(desconto extra)</span>';
        } else if (linhaCupom) linhaCupom.parentNode.removeChild(linhaCupom);
        pgTotal = Math.round(total * (100 - pgPct((st.comTop && t) ? 2 : 1)) / 100);
      }
      var vb = q('[data-ob-versao][aria-pressed="true"]');
      var resumo = [st.cor, vb ? vb.textContent.trim().toLowerCase() : null, st.tam ? 'tamanho ' + st.tam : null].filter(Boolean).join(', ');
      q('[data-ob-resumo]').textContent = resumo;
      if (q('[data-ob-cor-nome]')) q('[data-ob-cor-nome]').textContent = st.cor || '';
      if (q('[data-ob-foto-leg]')) q('[data-ob-foto-leg]').src = fotoDe(p, st.cor);
      desenhaCores(q('[data-ob-cores]'), p, st.cor, function (c) { st.cor = c; st.tam = null; pinta(); irParaFoto(peca(), c); });
      desenhaTamanhos(q('[data-ob-tam-leg]'), p, st.cor, st.tam, function (nome) { st.tam = nome; q('[data-ob-tam-leg]').classList.remove('tp-ob--chama'); pinta(); });

      if (t) {
        var addon = q('[data-ob-addon]');
        addon.classList.toggle('tp-ob__addon--on', st.comTop);
        q('[data-ob-addon-toggle]').checked = st.comTop;
        if (CB && !cbOk) q('[data-ob-top-preco]').innerHTML = cbEncerrado ? '' : '<b class="tp-ob__gratis">Só na ' + CB.cor + '</b>';
        else if (presente) q('[data-ob-top-preco]').innerHTML = '<s>' + brl(topP) + '</s> <b class="tp-ob__gratis">' + (topPago > 0 ? brl(topPago) : 'Grátis') + '</b>';
        else q('[data-ob-top-preco]').textContent = '+ ' + brl(topP);
        if (CB) {
          addon.classList.toggle('tp-ob__addon--bloq', !cbOk);
          q('[data-ob-addon-toggle]').disabled = !cbOk;
          var aviso = q('[data-ob-brinde-aviso]');
          if (aviso) {
            aviso.hidden = cbOk;
            aviso.innerHTML = cbOk ? '' : (cbEncerrado ? 'A oferta do top grátis já acabou.'
              : 'O top grátis vale só na LipLegging ' + CB.cor + '. <button type="button" data-ob-brinde-ir>Escolher a ' + CB.cor + '</button>');
          }
        }
        // top à escolha: o link da tabela abre a modal do top escolhido
        var guiaTop = q('[data-ob-top-guia]');
        if (guiaTop) { var gAlvo = st.topKey === 'topAlt' ? 'topalt' : 'top'; guiaTop.setAttribute('data-tp-size-guide-open', gAlvo); guiaTop.hidden = !document.getElementById('tp-size-guide-' + gAlvo); }
        if (q('[data-ob-cor-top-nome]')) q('[data-ob-cor-top-nome]').textContent = st.corTop || '';
        if (q('[data-ob-foto-top]')) q('[data-ob-foto-top]').src = fotoDe(t, st.corTop);
        desenhaCores(q('[data-ob-cores-top]'), t, st.corTop, function (c) { st.corTop = c; st.topEscolhido = true; st.tamTop = null; pinta(); });
        desenhaTamanhos(q('[data-ob-tam-top]'), t, st.corTop, st.tamTop, function (nome) { st.tamTop = nome; q('[data-ob-tam-top]').classList.remove('tp-ob--chama'); pinta(); });

        // ganhos do acréscimo: só o que o CONJUNTO alcança e a peça sozinha não.
        // No compre e ganhe (presente) o top é grátis e NÃO soma valor, então nunca dá para
        // usá-lo para atingir o mínimo de frete/brinde — as chips ficam de fora aqui.
        var kit = presente ? leg : leg + topP, ganhos = [], ganhaPresente = false, ganhaRoleta = false, rolNome = '';
        if (!presente) {
          if (dados.freteMin > 100 && leg < dados.freteMin && kit >= dados.freteMin) ganhos.push([ICO_FRETE, 'Frete grátis']);
          ganhaPresente = dados.presente && dados.presente.ativo && dados.presente.minimo > 0 && leg < dados.presente.minimo && kit >= dados.presente.minimo;
          // chips com FOTO (4º item): o brinde do par vem primeiro, é o argumento da campanha; a necessaire da loja depois
          if (ganhaPresente) ganhos.push([ICO_PRESENTE, (dados.presente.rotulo || 'Presente') + ' de presente', '', dados.presente.imagem || '']);
          // PRESENTE MISTERIOSO DA ROLETA (05/10/2026, pedido do Guilherme): so para quem girou
          // (localStorage), quando a peca sozinha nao chega ao minimo e o conjunto chega. O minimo
          // gravado pela roleta manda; sem ele, o do Liquid (R$ 399).
          var rol = dados.roleta, rolGanhou = false, rolMin = 0;
          try { rolGanhou = !!localStorage.getItem('tp-roleta-presente'); rolMin = parseInt(localStorage.getItem('tp-roleta-presente-minimo') || '0', 10) || 0; } catch (e) {}
          if (rol && !rolMin) rolMin = rol.minimo || 0;
          // Progressivo / Influs (06/10/2026): nessas PDPs o presente misterioso nao aparece (dados.prog.pct > 0)
          ganhaRoleta = !!(rol && rolGanhou && rolMin > 0 && leg < rolMin && kit >= rolMin && !(dados.prog && dados.prog.pct > 0));
          if (ganhaRoleta) {
            rolNome = (rol.rotulo || 'Presente surpresa').toLowerCase() + (rol.valor > 0 ? ' de ' + brl(rol.valor) : '');
            ganhos.push([ICO_PRESENTE, (rol.rotulo || 'Presente surpresa') + (rol.valor > 0 ? ' de ' + brl(rol.valor) : ''), '', rol.imagem || '']);
          }
          if (brindePar) ganhos.unshift([ICO_PRESENTE, brindePar.rotulo + ' de presente', 'tp-ob__ganho--brinde', brindePar.imagem || '']);
          // FRETE GRÁTIS NO SITE TODO (24/09/2026): com `freteMin` em R$ 1 (100 centavos), a regra de
          // cima nunca acende -- a peça sozinha já passa do mínimo. Mas a lista do acréscimo é o resumo
          // do que ela leva, e sem o frete ao lado da Necessaire parecia que o kit não tinha frete grátis.
          // Só entra junto de um presente: sozinho, o chip daria a entender que é o top que traz o frete.
          // E NÃO entra nas páginas com "Frete grátis para qualquer valor nesta página" (`ob_frete_gratis`,
          // atributo data-frete-gratis): ali o frete já é da peça sozinha e o texto da opção promete que o
          // chip some -- pedido do Guilherme para a LipLegging e o Top brancos (24/09/2026).
          // 05/10/2026 (pedido do Guilherme): o chip "Frete grátis" de companhia saiu dos ganhos do acréscimo.
          // O frete é do site todo e já aparece na faixa do topo; aqui só o que o conjunto conquista.
        }
        // com foto: cartãozinho com a foto (40px) e o ícone de presente no canto; sem foto: chip com ícone, como sempre
        q('[data-ob-ganhos]').innerHTML = ganhos.map(function (g) {
          // foto | ícone de presente grande | texto — o ícone solto no cartão, não grudado no canto da foto (pedido de 17/09)
          if (g[3]) return '<span class="tp-ob__ganho tp-ob__ganho--foto' + (g[2] ? ' ' + g[2] : '') + '"><img class="tp-ob__ganho-img" src="' + g[3] + '" alt=""><i class="tp-ob__ganho-ico">' + ICO_PRESENTE + '</i><span>' + g[1] + '</span></span>';
          return '<span class="tp-ob__ganho' + (g[2] ? ' ' + g[2] : '') + '">' + g[0] + g[1] + '</span>';
        }).join('');
        // frase curta abaixo do título: "Ganhe o Lenço Blumi e a Necessaire Blumi" (só os presentes; frete entra como chip)
        var fr = q('[data-ob-ganha-frase]');
        if (fr) {
          var nomes = [];
          if (!presente && brindePar) nomes.push(brindePar.rotulo);
          if (!presente && ganhaPresente) nomes.push(dados.presente.rotulo || 'presente');
          var frase = '';
          if (nomes.length) frase = 'Monte o kit e ganhe ' + nomes.join(' e ') + ' de presente' + (ganhaRoleta ? ', mais o ' + rolNome : '') + '.';
          else if (ganhaRoleta) frase = 'Monte o kit e leve o ' + rolNome + ' junto.';
          fr.textContent = frase;
          fr.hidden = !frase;
        }
      }

      fixa.querySelector('[data-ob-fixa-preco]').textContent = brl(pgTotal);
      fixa.querySelector('[data-ob-fixa-resumo]').textContent = resumo + (st.comTop && t ? ' + ' + pecaNome : '') + (freteGratis ? ' · frete grátis' : '');
      // AVISE-ME (19/10/2026): tamanho esgotado escolhido -> o botão (e o da barra fixa) só troca o texto
      var esg = esgotadoEscolhido();
      q('[data-ob-cta-texto]').textContent = esg ? rotuloAvise(esg.v.id) : ROTULO_CTA;
      fixa.querySelector('[data-ob-fixa-cta]').textContent = esg ? rotuloAvise(esg.v.id) : ROTULO_FIXA;
      if (CP) { try { document.dispatchEvent(new CustomEvent('tp:ob:cor', { detail: { cor: st.cor, promo: promoOn } })); } catch (e) {} }
    }

    /* ---------- eventos ---------- */
    qa('[data-ob-versao]').forEach(function (b) {
      b.addEventListener('click', function () {
        pressiona(b.parentElement, b);
        st.pecaKey = b.getAttribute('data-ob-versao');
        if (!dados.pecas[st.pecaKey]) st.pecaKey = 'legging';
        pinta();
        trocaGaleria(peca());
      });
    });
    /* TOP A ESCOLHA (20/10/2026): troca o top gratis. A cor fica (ou a equivalente); o tamanho fica quando o outro
       top tem o mesmo ("M (42 a 44)" no de alta sustentacao e "M" no Basic casam pela primeira palavra). */
    qa('[data-ob-top]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-ob-top');
        if (!dados.pecas[k] || k === st.topKey) return;
        pressiona(b.parentElement, b);
        var tamAntes = st.tamTop;
        st.topKey = k;
        var t = top();
        if (!corValida(t, st.corTop)) st.corTop = equivCor(t, st.corTop) || (CB ? equivCor(t, CB.cor) : null) || cores(t)[0] || null;
        st.tamTop = null;
        if (tamAntes) {
          var base = String(tamAntes).split(' ')[0];
          tamanhos(t, st.corTop).forEach(function (x) { if (!st.tamTop && x.disponivel && String(x.nome).split(' ')[0] === base) st.tamTop = x.nome; });
        }
        pinta();
      });
    });
    // aviso da cor do brinde: "Escolher a Café" volta a legging para a cor da oferta
    raiz.addEventListener('click', function (ev) {
      var ir = ev.target.closest && ev.target.closest('[data-ob-brinde-ir]');
      if (!ir || !CB) return;
      ev.preventDefault();
      var c = equivCor(peca(), CB.cor);
      if (!c) return;
      st.cor = c; st.tam = null; pinta(); irParaFoto(peca(), c);
    });
    var toggle = q('[data-ob-addon-toggle]');
    if (toggle) toggle.addEventListener('change', function () { st.comTop = toggle.checked; pinta(); });

    function rolaAte(el) { if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    function comprar(ev) {
      var p = peca(), t = top();
      if (!st.tam) { q('[data-ob-tam-leg]').classList.add('tp-ob--chama'); rolaAte(q('[data-ob-campo-tam]')); toast('Escolha o seu tamanho para continuar'); return; }
      var esg = esgotadoEscolhido();
      if (esg) {
        var alvo = (ev && ev.currentTarget) || q('[data-ob-cta]');
        if (window.tpAviseMe) window.tpAviseMe.abrir({ variantId: esg.v.id, item: esg.item, botao: alvo, rotuloEl: alvo.querySelector('[data-ob-cta-texto]') || alvo });
        return;
      }
      var vLeg = variante(p, st.cor, st.tam);
      if (!vLeg || !vLeg.available) { toast('Esse tamanho acabou nessa cor'); return; }
      var itens = [{ id: vLeg.id, quantity: 1 }];
      if (st.comTop && t) {
        if (!st.tamTop) { q('[data-ob-tam-top]').classList.add('tp-ob--chama'); rolaAte(q('[data-ob-addon]')); toast('Escolha o tamanho ' + pecaDe); return; }
        var vTop = variante(t, st.corTop, st.tamTop);
        if (!vTop || !vTop.available) { toast('Esse tamanho ' + pecaDe + ' acabou nessa cor'); return; }
        itens.push({ id: vTop.id, quantity: 1 });
      }
      // Compre e ganhe: as duas peças vão marcadas com uma etiqueta comum (_par), o mesmo contrato
      // do tp-kit — é o que faz a regra da Shopify zerar o top e o carrinho tratar o par como um só.
      if (travaPar && itens.length > 1) {
        var etiqueta = 'kit-' + Date.now();
        itens.forEach(function (it) { it.properties = { _par: etiqueta, _par_pecas: String(itens.length) }; });
      }
      var cta = q('[data-ob-cta]'), rotulo = q('[data-ob-cta-texto]').textContent;
      cta.disabled = true; q('[data-ob-cta-texto]').textContent = 'Adicionando...';
      var gaveta = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var corpo = { items: itens };
      if (gaveta && typeof gaveta.getSectionsToRender === 'function') {
        corpo.sections = gaveta.getSectionsToRender().map(function (s) { return s.id; });
        corpo.sections_url = window.location.pathname;
      }
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corpo)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'falha ao adicionar');
        if (gaveta && typeof gaveta.renderContents === 'function') { if (gaveta.classList.contains('is-empty')) gaveta.classList.remove('is-empty'); gaveta.renderContents(res); }
        /* SEM REDIRECT (pedido do Luiz, 12/09/2026). Havia um `else` que mandava
           para /cart quando a gaveta nao existia. A peca ja foi adicionada antes
           desta linha, entao nao perder nada -- o que se perde e a navegacao
           forcada, que tirava a cliente da pagina da oferta. */
        if (gaveta && typeof gaveta.open === 'function') gaveta.open();
      }).catch(function (err) {
        console.error('[tp-oferta-b]', err); toast('Não deu para adicionar agora. Tente de novo.');
      }).then(function () { cta.disabled = false; q('[data-ob-cta-texto]').textContent = rotulo; pinta(); });
    }
    q('[data-ob-cta]').addEventListener('click', comprar);
    fixa.querySelector('[data-ob-fixa-cta]').addEventListener('click', comprar);

    /* barra fixa: só depois que o botão principal já passou para cima */
    var cta = q('[data-ob-cta]');
    /* A coluna do produto (.product__info-wrapper.animate--slide-in) fica com um transform depois
       da animação de entrada, e transform vira "viewport" de qualquer position:fixed lá dentro:
       a barra grudava no fim da coluna, não no fim da tela. Por isso ela mora no body. */
    [].slice.call(document.body.children).forEach(function (el) { if (/(^|\s)tp-ob__(fixa|luz)(\s|$)/.test(el.className)) document.body.removeChild(el); });
    document.body.appendChild(fixa);
    // `data-fixa-sempre`: a barra aparece sempre que o botão NÃO está na tela, inclusive antes de ela chegar nele (pré-venda Blackout, 17/09). Sem o flag, só depois que o botão sobe.
    var fixaSempre = raiz.getAttribute('data-fixa-sempre') === '1';
    // `data-fixa-apos` (seletor CSS): a barra LIGA quando esse elemento passou para CIMA da tela (ex.: a frase do
    // cabeçalho, para a cliente ler o ângulo antes do botão fixo) e, uma vez ligada, NÃO some mais: nem voltando ao
    // topo, nem com o botão à vista. Menopausa, 02/10/2026. Pega o primeiro elemento VISÍVEL que casa com o seletor
    // (um display:none devolve retângulo zerado e nunca "passaria"). Sem seletor, vale a regra antiga abaixo.
    var fixaApos = raiz.getAttribute('data-fixa-apos'), fixaLigada = false;
    function fixaAposEl() { if (!fixaApos) return null; var ls = document.querySelectorAll(fixaApos); for (var i = 0; i < ls.length; i++) { if (ls[i].getClientRects().length) return ls[i]; } return null; }
    function mostraFixa() {
      var r = cta.getBoundingClientRect();
      if (fixaApos) {
        var el = fixaAposEl();
        if (!fixaLigada && ((el && el.getBoundingClientRect().bottom < 0) || r.bottom < 0)) fixaLigada = true;
        fixa.hidden = !fixaLigada; return;
      }
      fixa.hidden = fixaSempre ? !(r.bottom < 0 || r.top > window.innerHeight) : !(r.bottom < 0);
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(mostraFixa, { threshold: 0 }).observe(cta);
    var esperando = false;
    window.addEventListener('scroll', function () { if (esperando) return; esperando = true; requestAnimationFrame(function () { mostraFixa(); esperando = false; }); }, { passive: true });

    /* ---------- prazo de entrega ---------- */
    var MES = ['jan.', 'fev.', 'mar.', 'abr.', 'mai.', 'jun.', 'jul.', 'ago.', 'set.', 'out.', 'nov.', 'dez.'], DIA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
    function uteis(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
    function fmt(d) { return DIA[d.getDay()] + ', ' + d.getDate() + ' de ' + MES[d.getMonth()]; }
    function proximoCorte() { var n = new Date(), c = new Date(n.getFullYear(), n.getMonth(), n.getDate(), CFG.corte, 0, 0); if (n >= c) c.setDate(c.getDate() + 1); return c; }
    function despacho() { if (despachoFixo) return new Date(despachoFixo); var d = new Date(proximoCorte()); if (d.getDay() === 6) d.setDate(d.getDate() + 2); if (d.getDay() === 0) d.setDate(d.getDate() + 1); return d; }
    var entTitulo = q('[data-ob-ent-titulo]'), entCorte = q('[data-ob-ent-corte]');
    // mesmo mês: "qua, 16 e ter, 22 de set." cabe numa linha no celular; o mês repetido quebrava
    function faixa(ini, fim) { return 'Chega entre ' + (ini.getMonth() === fim.getMonth() ? DIA[ini.getDay()] + ', ' + ini.getDate() : fmt(ini)) + ' e ' + fmt(fim); }
    function faixaGeral() { var d = despacho(); entTitulo.innerHTML = faixa(uteis(d, CFG.min), uteis(d, CFG.max)); }
    function relogio() { if (!entCorte) return; var seg = Math.max(0, Math.floor((proximoCorte() - new Date()) / 1000)), h = Math.floor(seg / 3600), m = Math.floor(seg % 3600 / 60); entCorte.textContent = (h > 0 ? h + 'h ' : '') + m + 'min'; }
    if (entTitulo) { faixaGeral(); if (entCorte && !despachoFixo) { relogio(); setInterval(relogio, 30000); } }

    // estimativa por estado (dias úteis do Frete Padrão na capital, medidos em 10/09/2026, +2 para o interior)
    // dias úteis do despacho até a entrega pelo FRETE PADRÃO (onde ele não existe, pela PAC), medido no Frenet em
    // 11/09/2026 por capital; a faixa alta cobre o interior. A data por CEP (consultaCep) é a de verdade, também no Frete Padrão.
    var UF_DIAS = { SP: [1, 3], PR: [1, 3], SC: [2, 4], MG: [2, 4], RJ: [2, 4], RS: [2, 4], ES: [3, 5], GO: [3, 5], MS: [4, 6], BA: [4, 6], PE: [5, 7], CE: [6, 8], DF: [6, 8], SE: [6, 8], TO: [6, 9], MT: [7, 9], RN: [7, 9], AL: [8, 10], PI: [8, 11], PA: [8, 11], PB: [9, 11], RO: [9, 12], MA: [10, 13], AP: [11, 14], AC: [12, 15], RR: [14, 17], AM: [20, 23] };
    var cepForm = q('[data-ob-cep-form]'), cepIn = q('[data-ob-cep]'), cepErro = q('[data-ob-cep-erro]');
    function erroCep(msg) { cepErro.textContent = msg; cepErro.hidden = false; }
    function pintaData(ini, fim, cepTxt, exata) {
      var texto = (ini.getTime() === fim.getTime() ? 'Chega até ' + fmt(fim) : faixa(ini, fim));
      entTitulo.innerHTML = texto + ' <span class="tp-ob__entrega-uf">no CEP ' + cepTxt + (exata ? '' : ' (estimativa)') + ' · <a href="#" data-ob-troca-cep>Trocar</a></span>';
      cepForm.hidden = true;
      try { localStorage.setItem('blumi_cep', cepTxt.replace(/\D/g, '')); } catch (e) { }
    }
    function dataDeStr(s) { var p = String(s).split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
    function consultaCep(c) {
      cepErro.hidden = true;
      fetch('https://viacep.com.br/ws/' + c + '/json/').then(function (r) { return r.json(); }).then(function (v) {
        if (!v || v.erro) { erroCep('CEP não encontrado.'); return; }
        var uf = v.uf, cepTxt = c.slice(0, 5) + '-' + c.slice(5);
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          // com despacho fixo (pré-venda) a transportadora responderia como se o envio fosse hoje: fica a estimativa por UF a partir da data de envio
          if (cart && cart.item_count > 0 && !despachoFixo) {
            var url = '/cart/shipping_rates.json?shipping_address[zip]=' + c + '&shipping_address[country]=BR&shipping_address[province]=' + encodeURIComponent(uf);
            return fetch(url).then(function (r) { return r.json(); }).then(function (d) {
              var rs = ((d && d.shipping_rates) || []).filter(function (r) { return r.delivery_range && r.delivery_range.length; });
              // sempre o FRETE PADRÃO; onde ele não existe (alguns estados do Norte/Nordeste) cai na PAC, o outro
              // frete de piso; só então na que chega antes. Ordenar por preço não serve: com frete grátis é tudo R$ 0.
              function porNome(re) { return rs.filter(function (r) { return re.test(r.name); }).sort(function (a, b) { return a.delivery_range[0] < b.delivery_range[0] ? -1 : 1; })[0]; }
              var esc = porNome(/padr/i) || porNome(/\bpac\b/i) || rs.slice().sort(function (a, b) { return a.delivery_range[0] < b.delivery_range[0] ? -1 : 1; })[0];
              if (esc) { pintaData(dataDeStr(esc.delivery_range[0]), dataDeStr(esc.delivery_range[esc.delivery_range.length - 1]), cepTxt, true); return; }
              estimaUf(uf, cepTxt);
            });
          }
          estimaUf(uf, cepTxt);
        });
      }).catch(function () { erroCep('Não deu para consultar agora. Tente de novo.'); });
    }
    function estimaUf(uf, cepTxt) { var f = UF_DIAS[uf]; if (!f) { erroCep('CEP não encontrado.'); return; } var d = despacho(); pintaData(uteis(d, f[0]), uteis(d, f[1]), cepTxt, false); }

    // Estado pelo IP, quando ela ainda não deu o CEP: "Chega entre ... para Santa Catarina · Não é o seu estado?".
    // O serviço é o GeoJS (grátis, sem chave, aceita chamada do navegador). Sem resposta ou fora do Brasil, fica a
    // regra geral. A UF fica guardada 7 dias para não consultar em toda página.
    var UF_NOME = { AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás', MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins' };
    function ufDoNome(nome) { var n = semAcento(nome); for (var k in UF_NOME) { if (semAcento(UF_NOME[k]) === n) return k; } return null; }
    function faixaUf(uf) {
      var f = UF_DIAS[uf]; if (!f) return false;
      var d = despacho();
      entTitulo.innerHTML = faixa(uteis(d, f[0]), uteis(d, f[1])) + ' <span class="tp-ob__entrega-uf">para ' + UF_NOME[uf] + ' · <a href="#" data-ob-troca-cep>Não é o seu estado?</a></span>';
      cepForm.hidden = true;
      return true;
    }
    function detectaUf() {
      var guardada = null;
      try { var g = JSON.parse(localStorage.getItem('blumi_uf') || 'null'); if (g && g.uf && Date.now() - g.em < 7 * 864e5) guardada = g.uf; } catch (e) { }
      if (guardada) { faixaUf(guardada); return; }
      if (!window.fetch) return;
      fetch('https://get.geojs.io/v1/ip/geo.json').then(function (r) { return r.json(); }).then(function (g) {
        if (!g || g.country_code !== 'BR') return;
        var uf = ufDoNome(g.region || '');
        if (uf && faixaUf(uf)) { try { localStorage.setItem('blumi_uf', JSON.stringify({ uf: uf, em: Date.now() })); } catch (e) { } }
      }).catch(function () { });
    }
    if (cepIn) {
      cepIn.addEventListener('input', function () { var v = cepIn.value.replace(/\D/g, '').slice(0, 8); cepIn.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; });
      cepForm.addEventListener('submit', function (e) { e.preventDefault(); var c = cepIn.value.replace(/\D/g, ''); if (c.length !== 8) { erroCep('Digite os 8 números do CEP.'); return; } consultaCep(c); });
      raiz.addEventListener('click', function (e) { var t = e.target.closest('[data-ob-troca-cep]'); if (!t) return; e.preventDefault(); faixaGeral(); cepForm.hidden = false; cepIn.value = ''; cepIn.focus(); try { localStorage.removeItem('blumi_cep'); localStorage.removeItem('blumi_uf'); } catch (x) { } });
      var salvo = null;
      try { salvo = localStorage.getItem('blumi_cep'); } catch (e) { }
      if (salvo && salvo.length === 8) { cepIn.value = salvo.slice(0, 5) + '-' + salvo.slice(5); consultaCep(salvo); } else { detectaUf(); }
    }

    /* ---------- popup com as fotos da cor ---------- */
    var luz = q('[data-ob-luz]'), thumb = q('[data-ob-abre-fotos]');
    if (luz && thumb) {
      document.body.appendChild(luz); // mesmo motivo da barra fixa: position:fixed dentro da coluna animada
      var luzTrack = luz.querySelector('[data-ob-luz-track]'), luzThumbs = luz.querySelector('[data-ob-luz-thumbs]'), luzConta = luz.querySelector('[data-ob-luz-conta]'), luzTitulo = luz.querySelector('[data-ob-luz-titulo]');
      var luzFechar = luz.querySelector('[data-ob-luz-fechar]'), luzAnt = luz.querySelector('[data-ob-luz-ant]'), luzProx = luz.querySelector('[data-ob-luz-prox]'), luzN = 0;
      function luzIndice() { return luzTrack.clientWidth ? Math.min(luzN - 1, Math.round(luzTrack.scrollLeft / luzTrack.clientWidth)) : 0; }
      function luzVai(i) {
        var x = Math.max(0, Math.min(luzN - 1, i)) * luzTrack.clientWidth;
        if ('scrollBehavior' in document.documentElement.style) luzTrack.scrollTo({ left: x, behavior: 'smooth' }); else luzTrack.scrollLeft = x;
      }
      function luzPinta() {
        var i = luzIndice();
        luzConta.textContent = (i + 1) + ' / ' + luzN;
        luzAnt.disabled = i === 0; luzProx.disabled = i >= luzN - 1;
        [].slice.call(luzThumbs.children).forEach(function (b, k) {
          b.setAttribute('aria-current', k === i ? 'true' : 'false');
          if (k === i) luzThumbs.scrollLeft = b.offsetLeft - (luzThumbs.clientWidth - b.offsetWidth) / 2;
        });
      }
      function abreLuz(pr, cor) {
        var p = pr || peca(); cor = cor || st.cor; var fotos = fotosDe(p, cor); luzN = fotos.length;
        luzTrack.innerHTML = ''; luzThumbs.innerHTML = '';
        fotos.forEach(function (u, i) {
          var im = document.createElement('img'); im.src = u; im.alt = p.title + ' ' + cor + ', foto ' + (i + 1); if (i) im.loading = 'lazy'; luzTrack.appendChild(im);
          var b = document.createElement('button'); b.type = 'button'; b.className = 'tp-ob__luz-thumb'; b.setAttribute('aria-label', 'Foto ' + (i + 1));
          var mi = document.createElement('img'); mi.src = u.replace(/width=\d+/, 'width=160'); mi.alt = ''; b.appendChild(mi);
          b.addEventListener('click', function () { luzVai(i); });
          luzThumbs.appendChild(b);
        });
        luzTitulo.textContent = p.title + ' · ' + cor;
        luz.hidden = false; luzTrack.scrollLeft = 0; luzPinta();
        document.documentElement.classList.add('tp-ob-luz-aberta'); luzFechar.focus();
      }
      function fechaLuz() { luz.hidden = true; document.documentElement.classList.remove('tp-ob-luz-aberta'); thumb.focus(); }
      thumb.addEventListener('click', function () { abreLuz(peca(), st.cor); });
      // miniatura do acréscimo: mesmas fotos, do top; preventDefault por estar dentro do <label> da caixa de marcar
      var thumbTop = q('[data-ob-abre-fotos-top]');
      if (thumbTop) thumbTop.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (top()) abreLuz(top(), st.corTop); });
      luzFechar.addEventListener('click', fechaLuz);
      luzAnt.addEventListener('click', function () { luzVai(luzIndice() - 1); });
      luzProx.addEventListener('click', function () { luzVai(luzIndice() + 1); });
      luz.addEventListener('click', function (e) { if (e.target === luz) fechaLuz(); });
      if (!window.__tpObEsc) {
        window.__tpObEsc = true;
        document.addEventListener('keydown', function (e) { if (e.key !== 'Escape') return; var aberta = document.querySelector('.tp-ob__luz:not([hidden]) [data-ob-luz-fechar]'); if (aberta) aberta.click(); });
      }
      var luzEsperando = false;
      luzTrack.addEventListener('scroll', function () { if (luzEsperando) return; luzEsperando = true; requestAnimationFrame(function () { luzPinta(); luzEsperando = false; }); }, { passive: true });
    }

    /* ---------- vídeos: fachada, só carrega o mp4 ao tocar ---------- */
    // O Liquid só entrega o mp4 original (1080p, 7,2 Mbps: demora a começar no celular). O CDN da Shopify
    // guarda a versão 480p no mesmo caminho, só muda o rótulo; se ela não existir, o erro volta para o original.
    function leve(url) { return url.replace('HD-1080p-7.2Mbps', 'SD-480p-1.5Mbps').replace('HD-1080p-2.5Mbps', 'SD-480p-0.9Mbps'); }
    raiz.addEventListener('click', function (e) {
      var it = e.target.closest('[data-ob-ugc]'); if (!it || it.classList.contains('tp-ob__ugc-item--tocando') || !it.getAttribute('data-src')) return;
      qa('video.tp-ob__ugc-video').forEach(function (vd) { vd.pause(); });
      var v = document.createElement('video'); v.className = 'tp-ob__ugc-video'; v.src = leve(it.getAttribute('data-src')); v.controls = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('preload', 'auto');
      v.addEventListener('error', function () { var orig = it.getAttribute('data-src'); if (v.src !== orig) { v.src = orig; v.play().catch(function () { }); } });
      it.classList.add('tp-ob__ugc-item--tocando'); it.appendChild(v); v.play().catch(function () { });
    });

    pinta();
    // TESTE DE PREÇO: grupo que o VWO definiu depois de a caixa nascer -> redesenha com o preço dele
    document.addEventListener('tp:teste-preco', function () {
      if (!raiz.isConnected || !window.tpTestePreco) return;
      window.tpTestePreco.ajustarOferta(dados);
      pinta();
    });
    // cor do dia escolhida de saida: a galeria vai para a foto dela (a pagina nao se move; ver irParaFoto)
    if (CP && !corUrl && st.cor === CP.cor) setTimeout(function () { irParaFoto(peca(), st.cor); }, 400);
  }

  /* No editor de tema a seção é redesenhada a cada mudança (shopify:section:load) e o HTML novo
     chega sem os eventos: por isso a inicialização é uma função, chamada de novo para a seção nova. */
  function iniciaTodas(escopo) { [].slice.call((escopo || document).querySelectorAll('[data-tp-ob]')).forEach(inicia); }
  iniciaTodas();
  document.addEventListener('shopify:section:load', function (e) { iniciaTodas(e.target); });
})();
/* reenvio 28/09/2026 14:5x: o sync GitHub->Shopify aplicou o push quebrado e perdeu o conserto seguinte */
/* reenvio 28/09/2026 15:3x: o sync perdeu o push do religar por timer */
/* reenvio 28/09/2026 16:3x: o sync perdeu o push anterior na main */
